import { cn } from "@acme/ui";
import { Tabs, TabsList, TabsTrigger } from "@acme/ui/tabs";
import { createFileRoute, Outlet, useLocation } from "@tanstack/react-router";
import { useTranslation } from "react-i18next";
import type { FileRoutesByTo } from "~/routeTree.gen.js";

export const Route = createFileRoute("/_authed/my-players/$tag/clan-search")({
  component: ClanSearchLayout,
});

const SUB_TABS = [
  {
    value: "filters",
    to: "/my-players/$tag/clan-search/filters",
    labelKey: "searchResults.tabs.filters",
  },
  {
    value: "results",
    to: "/my-players/$tag/clan-search/results",
    labelKey: "searchResults.tabs.results",
  },
] as const satisfies {
  value: "filters" | "results";
  to: keyof FileRoutesByTo;
  labelKey: string;
}[];

function ClanSearchLayout() {
  const { t } = useTranslation();
  const { tag } = Route.useParams();
  const location = useLocation();
  const navigate = Route.useNavigate();

  const activeTab =
    SUB_TABS.find((tab) =>
      tab.value === "results"
        ? location.pathname.endsWith("/results")
        : location.pathname.includes("/filters")
    )?.value ?? "filters";

  return (
    <div className="space-y-6">
      <Tabs
        onValueChange={(value) => {
          const tab = SUB_TABS.find((item) => item.value === value);
          if (tab == null) return;
          void navigate({ to: tab.to, params: { tag } });
        }}
        value={activeTab}>
        <TabsList className={cn("h-auto flex-wrap")}>
          {SUB_TABS.map(({ value, labelKey }) => (
            <TabsTrigger key={value} value={value}>
              {t(labelKey)}
            </TabsTrigger>
          ))}
        </TabsList>
      </Tabs>
      <Outlet />
    </div>
  );
}
